import { render, staticRenderFns } from "./HomeReview.vue?vue&type=template&id=294b16a7"
import script from "./HomeReview.vue?vue&type=script&lang=js"
export * from "./HomeReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports